function MixcloudPlayer(el) {
    this.el = el;
    this.mainStream = document.querySelector('.jsMainStream video');

    document.body.addEventListener('click', e => {
        if (e.target.classList.contains('jsMixcloudTrigger')) {
            e.preventDefault();

            if (typeof e.target.dataset.mixcloudEmbed !== 'undefined' && e.target.dataset.mixcloudEmbed) {
                this.updatePlayerEmbed(e.target.dataset.mixcloudEmbed);
            }
        }
    });
}

MixcloudPlayer.prototype.updatePlayerEmbed = function(embedCode) {
    this.el.innerHTML = embedCode;
    this.el.classList.add('visible');

    if (this.mainStream) this.mainStream.pause();
};

(function() {
    const mixcloudPlayerEl = document.querySelector('.jsMixcloudPlayer');
    if (mixcloudPlayerEl) new MixcloudPlayer(mixcloudPlayerEl);
})();
